export const isChromeExtension = !!(window as any).chrome?.extension;
